import { Vue } from "vue-property-decorator";

export const MsalUtility = new Vue({
  methods: {
    logout(redirectToRouteName?: string) {
      this.$msal.logout(redirectToRouteName);
    },
  },
});
